import React from 'react';
import PropTypes from 'prop-types';
import Button from "@/componentsDS/Button/Button";
import { ButtonType, ButtonVariant } from '@/componentsDS/Button/Button.type';
function AddRelation({
	selectOrgIds,
	consumeDataElement,
	sendDataElement,
	orgEmailList,
	orgEmail,
	isOrgEmailValid,
	onClick,
	text,
	id = undefined
}) {
	const hasSelectedOrgs = selectOrgIds?.length > 0;
	const hasDataElements =
		consumeDataElement?.length > 0 || sendDataElement?.length > 0;

	const isInvitingOrg = selectOrgIds?.some(
		item => item.value === 'inviteNewUser'
	);

	const isOrgEmailValidForInvite =
		(orgEmailList.length === 0 && orgEmail.length > 0 && isOrgEmailValid) ||
		(orgEmailList.length > 0 && orgEmail.length > 0 && isOrgEmailValid) ||
		(orgEmailList.length > 0 && orgEmail.length === 0);

	const orgInviteConditionMet = !isInvitingOrg || isOrgEmailValidForInvite;

	const shouldDisable = !hasSelectedOrgs || !hasDataElements || !orgInviteConditionMet;

	return (
		<Button
			variant={ButtonVariant.STANDARD}
			type={ButtonType.SOLID}
			data-testid="add-button"
			text={text}
			disabled={shouldDisable}
			onClick={onClick}
			id={id}
		/>
	);
}

AddRelation.propTypes = {
	selectOrgIds: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string.isRequired,
		})
	).isRequired,
	consumeDataElement: PropTypes.array.isRequired,
	sendDataElement: PropTypes.array.isRequired,
	orgEmailList: PropTypes.arrayOf(PropTypes.string).isRequired,
	orgEmail: PropTypes.string.isRequired,
	isOrgEmailValid: PropTypes.bool.isRequired,
	onClick: PropTypes.func.isRequired,
	text: PropTypes.string.isRequired,
	id: PropTypes.string
};

export default AddRelation;
